import dateUtils from '@utils/DateUtils'
import config from '@/config'
import sizeUtils from '@utils/sizeUtils'
import BaseModel from '@/models/base-model'

let defaultIcon = require('@assets/model_default_thumb.svg')
export default class Model extends BaseModel {
  constructor (model) {
    super(model)
    this._createdAt = model.created_at
    this._updatedAt = model.updated_at
    this._createdBy = model.owner
    this._description = model.description
    this._meta = model.meta
    this._type = model.type
    this._size = model.size_mb ? this.transf(model.size_mb) : 'None'
    this._icon = model.thumbnail ? config.php_url + model.thumbnail : defaultIcon
    this._deletable = model.deletable
    this._owner = model.owner ? model.owner : undefined
    this._sku = model.sku ? model.sku : undefined
    this._background = model.background ? model.background : undefined
    this._avatar = model.avatar ? model.avatar : undefined
    this._images = model.images ? model.images : undefined
    this._categories = model.categories ? model.categories : []
    this._modelType = this.transformType(model.type)
    this._outputType = model.output_type
    this._itemType = 'model'
    this._unixCreatedAt = model.created_at ? new Date(model.created_at).getTime() : undefined
    this._permission = model.permission
    this._versions = model.versions
    this._allow_ssr_usage = model.allow_ssr_usage
    this._datasets = model.datasets
    this._download_url = model.download_url
  }
  transf (size) {
    return sizeUtils.transfSize(size)
  }

  transformType (type) {
    switch (type) {
      case 'unet':
      case 'unet50':
      case 'deforest':
      case 'pixel_magic':
        return type
      default:
        return 'mrcnn'
    }
  }

  get size () {
    return this._size
  }
  get modelType () {
    return this._modelType
  }
  get categories () {
    return this._categories
  }
  get images () {
    return this._images
  }

  get owner () {
    return this._owner
  }

  get sku () {
    return this._sku
  }

  get type () {
    return this._type
  }

  get background () {
    return this._background
  }

  get avatar () {
    return this._avatar
  }

  get icon () {
    return this._icon
  }

  get editable () {
    return this._deletable
  }

  get id () {
    return this._id
  }

  set id (val) {
    this._type = val
  }

  get description () {
    return this._description
  }

  get createdAt () {
    return dateUtils.convertUTCToLocalDate(this._createdAt)
  }

  get createdBy () {
    return this._createdBy
  }

  get updatedAt () {
    return dateUtils.convertUTCToLocalDate(this._updatedAt)
  }

  get meta () {
    return this._meta
  }

  set meta (val) {
    this._meta = val
  }

  get name () {
    return this._name
  }

  set name (val) {
    this._name = val
  }

  get outputType () {
    return this._outputType
  }

  get itemType () {
    return this._itemType
  }

  get unixCreatedAt () {
    return this._unixCreatedAt
  }

  get permission () {
    return this._permission
  }

  get versions () {
    return this._versions
  }

  get datasets () {
    return this._datasets
  }

  get download_url () {
    return this._download_url
  }
}



// WEBPACK FOOTER //
// ./src/models/model/model.js